import React from "react";
import { useState, useEffect } from "react";

import { showToastError, showToastSuccess } from "../../Utils/Helper";
import Loader from "../../commonComponent/Loader";
import { FiEdit, FiSearch, FiTrash } from "react-icons/fi";
import { AiFillEye, AiOutlinePlus } from "react-icons/ai";
import { useLocation, useNavigate } from "react-router-dom";

import SquareAvatar from "../../commonComponent/SquareAvatar";
import DeleteModal from "../../commonComponent/DeleteModal";

import Navbar from "../header/Navbar";
import Sidebar from "../sidebar/Sidebar";
import ApiConfig from "../../config/ApiConfig";
import { format, parseISO } from "date-fns";
import {
  addCareTeam,
  getAllCareTeamGroupProgramsList,
  getCareTeams,
  getCareTeamsforAdmin,
} from "../../services/CareTeam";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import { useAuth } from "../../Context/AuthContext";
import { useCareTeamContext } from "../../Context/CareTeamContext";

const TotalProgramList = (props) => {
  const [sortBy, setSortBy] = useState("");

  const {isAdmin} = useAuth();
  const isManager = JSON.parse(localStorage.getItem('user_id'))
  const location = useLocation()
  const {careId} = location?.state
  const [memberList, setMemberList] = useState([]);
  const [allCareTeams, setAllCareTeams] = useState([]);
  const [dropDownList, setDropDownList] = useState(false);
  const [isLoading, setLoader] = useState(true);
  const [pid, setPID] = useState();
  const [team, setTeam] = useState();
  const [filterdata, setFilterData] = useState([]);
  const navigate = useNavigate();
  const {renderProgramSignal} = useCareTeamContext()


  useEffect(() => {
    getProgramList();
    getAllCareTeamsNew();
    setSortBy('')
  }, []);

  useEffect(() => {
    if(renderProgramSignal){
      getProgramList();
      setSortBy("")
    }
  },[renderProgramSignal])

  let dateSort = (filterdata1) => {
    setDropDownList(false);
    const result = filterdata1.sort(function (a, b) {
      a = new Date(a.createdAt);
      b = new Date(b.createdAt);
      return a > b ? -1 : a < b ? 1 : 0;
    });
    return result;
  };
  let nameSort = (filterdata1) => {
    setDropDownList(false);
    const result = filterdata1.sort(function compare(a, b) {
      const nameA = (a.programName || "").toLowerCase().replace(/\s/g, "");
      const nameB = (b.programName || "").toLowerCase().replace(/\s/g, "");
      // Custom comparison for undefined, null, empty string, and objects
      if (!nameA && !nameB) return 0; // Both are empty, treat them as equal
      if (!nameA) return 1; // Empty string, null, undefined, or object goes to the bottom
      if (!nameB) return -1;
      return nameA.localeCompare(nameB);
    });
    return result;
  };

  const getProgramList = async () => {
    try {
      const response = await getAllCareTeamGroupProgramsList("program", careId);
      setLoader(false);
      if (response.status === 200) {
        setMemberList(response?.data?.data);
        setFilterData(response?.data?.data);
      } else {
        console.log(response?.data || response.message);
      }
    } catch (error) {
      setLoader(false);
      error?.data?.data &&
        console.log(error?.data?.data || error.data?.message);
    }
  };

  const onMemberSearch = async (e) => {
    let searchWord = e.target.value;
    const result = memberList?.filter((value) => {
      if (value) {
        return value?.programName
          ?.toLowerCase()
          ?.includes(searchWord?.toLowerCase());
      }
      return false;
    });

    if (searchWord === "") {
      setFilterData(memberList);
    } else {
      setFilterData(result);
    }
  };

  const removeGroup = async (programId, team) => {
    console.log("team ===>", team);
    let payload = {
      teamName: team.teamName,
      description: team.description,
      teamMeambers: team.teamMeambers?.map((member => member._id)),
      teamManager: team.teamManager,
      groups: team.groups.map((item) => item._id),
      programs: team.programs
        .filter((program) => program._id !== programId)
        .map((program) => program._id),
      status: team.status,
    };
    try {
      const response = await addCareTeam(payload, team._id);
      if (response) {
        showToastSuccess(response?.data || "Program removed successfully.");
        getProgramList();
      } else {
        showToastError(
          response?.data || response.message || "Some error occurred"
        );
      }
    } catch (error) {
      showToastError(
        error?.data?.data || error.data?.message || "Some error occurred"
      );
    }
  };

  const renderSearchHeader = () => {
    const menuClass = `dropdown-menu${dropDownList ? " show" : ""}`;
    return (
      <div className="col-md-12 d-flex">
        <div className="w-50">
          <h4 className="headFont">Programs</h4>
          <p className="resFont">See how your programs are doing</p>
        </div>
        <div className="w-50 d-flex">
          <div className="actsearch_simple me-2">
            <FiSearch className="boxicon" />
            <input
              placeholder="Search for a member..."
              className="ms-2"
              onChange={(e) => onMemberSearch(e)}
            />
          </div>
          <div className="dropdown me-2">
            <button
              onBlur={() => {
                setDropDownList(false);
              }}
              onClick={() => {
                setDropDownList(!dropDownList);
              }}
              className="btn btn-custom-filter position-relative dropdown-toggle"
              type="button"
            >
               {sortBy === "atoz" ? 'Alphabetical' : sortBy === 'bydate' ? "Date" : "Filter"}
              <ul
                className={menuClass + " top-0 start-0 w-100"}
                style={{ marginTop: "3.5em" }}
              >
                <li>
                  <span
                    className="dropdown-item pointer"
                    onClick={() => {
                      nameSort(filterdata);
                      setSortBy('atoz')
                    }}
                  >
                    Alphabetical Order
                  </span>
                </li>
                <li>
                  <span
                    className="dropdown-item pointer"
                    onClick={() => {
                      dateSort(filterdata);
                      setSortBy('bydate')
                    }}
                  >
                    Date Order
                  </span>
                </li>
              </ul>
            </button>
          </div>
          <div className="dropdown me-2">
            <button className="btn btn-primary btn-custom" type="button"
             onClick={() => navigate("/createactiveprogram")}
            >
              <AiOutlinePlus className="me-2" /> Add program
            </button>
          </div>
        </div>

        <DeleteModal
          title={"Delete"}
          content1={"Are you sure you want to remove"}
          content2={"this program?"}
          modalId={"programdelete"}
          button2={"No"}
          button1={"Yes"}
          onDelete={() => removeGroup(pid, team)}
        />
      </div>
    );
  };

  const getAllCareTeamsNew = async () => {
    try {
      const response = isAdmin
      ? await getCareTeamsforAdmin()
      : await getCareTeams();
      if (response.status !== 200) {
        setAllCareTeams([]);
        return [];
      }
      setAllCareTeams(response?.data?.data);
    } catch (error) {
      console.log(error);
    }
  };

  const getTeamName = (id) => {
    const result = allCareTeams
      .filter((careteam) =>
        careteam.programs.find((program) => program._id === id)
      )
      .map((team) => team);
    return result[0];
  };

  const renderListRow = (item) => {
    let updated =
      item.updatedBy &&
      (item.updatedBy !== item.createdBy ? item?.updatedBy : item?.createdBy);
    return (
      <tr
        key={item?._id}
        className="pointer position-relative"
        onClick={() => {
          navigate("/activeprograminfo", {
            state: { program: item },
          });
        }}
      >
        <td className="text-muted avatar_warper position-static py-2 col-md-1">
          <SquareAvatar
            src={
              ApiConfig.ImageUrl +
              "programs/" +
              updated +
              "/" +
              item.programImage
            }
            alt="image"
            className="member_listimage squre_image2"
          />
        </td>
        <td className="text-muted py-2 col-md-2">
          {item?.full_name !== " " ? `${item?.programName}` : "N/A"}
        </td>
        <td className="text-muted py-2 col-md-1">
          {getTeamName(item?._id)?.teamName || "-"}
        </td>
        <td className="text-muted py-2 col-md-1">
          {item?.createdAt
            ? format(parseISO(item?.createdAt), "MMM d, yyyy")
            : null}
        </td>
        <td className="text-muted py-2 col-md-1">
          {item?.programMembers.length}
        </td>
        <td
          className="text-muted fw-bold py-2 col-md-1"
          style={{ cursor: "pointer" }}
        >
          <div className="d-flex gap-1">
            <button
              onClick={(e) => {
                navigate("/activeprograminfo", {
                  state: { program: item },
                });
                e.stopPropagation();
              }}
              className="btn btn-light"
            >
              <AiFillEye className="mb-1" />
            </button>
            {(isAdmin || isManager === getTeamName(item?._id)?.teamManager || isManager === item.createdBy) && (
              <button
                onClick={(e) => {
                  e.stopPropagation();

                  navigate("/activeprogram", {
                    state: { program: item, isFromCreate: false, isFromCareTeam:true },
                  });
                }}
                className="btn btn-light"
              >
                <FiEdit className="mb-1" />
              </button>
            )}
            {(isAdmin || isManager === getTeamName(item?._id)?.teamManager || isManager === item.createdBy) && (
              <button
                data-bs-toggle={"modal"}
                data-bs-target={"#programdelete"}
                className="btn btn-light"
                onClick={(e) => {
                  e.stopPropagation();
                  setTeam(getTeamName(item?._id));
                  setPID(item._id);
                }}
              >
                <FiTrash className="mb-1" />
              </button>
            )}
          </div>
        </td>
      </tr>
    );
  };

  const renderList = () => {
    return (
      <tbody>
        {filterdata?.map((item) => {
          return renderListRow(item);
        })}
      </tbody>
    );
  };

  return (
    <>
      <Navbar />
      <div className="container-fluid mb-5">
        <div className="row">
          <div className="col-md-2">
            <Sidebar />
          </div>
          <div className="col-md-10 py-4 px-5">
            <nav aria-label="breadcrumb col-md-12">
              <ol className="breadcrumb">
                <li
                  class="breadcrumb-item cursor-pointer"
                  onClick={() => navigate("/")}
                >
                  Home
                </li>
                <li
                  className="breadcrumb-item active fw-bold pointer"
                  aria-current="page"
                  onClick={() => navigate(-1)}
                >
                  Care Team
                </li>
                <li
                  className="breadcrumb-item active fw-bold pointer"
                  aria-current="page"
                >
                  Programs
                </li>
              </ol>
            </nav>
            <div className="mt-4" style={{ height: "auto" }}>
              {renderSearchHeader()}
            </div>
            <Tabs>
              <TabList>
                <Tab>Care Team Programs</Tab>
              </TabList>
              <TabPanel>
                <div className="memlist_scroll_careTeam row me-0 ms-0 mt-4 spacing_scroll">
                  {isLoading && (
                    <Loader
                      visible={isLoading}
                      showBR={false}
                      emptyTextKey={"noAnyActiveMember"}
                    />
                  )}
                  {!isLoading && (
                    <table className="table table-hover ">
                      <thead>
                        <tr>
                          <td className="py-4">Thumbnail</td>
                          <td className="py-4">Program Title</td>
                          <td className="py-4">Care Team Name</td>
                          <td className="py-4">Created At</td>
                          <td className="py-4"> No. of Participants</td>
                          <td className="py-4">Action</td>
                        </tr>
                      </thead>
                      {renderList()}
                    </table>
                  )}
                </div>
              </TabPanel>
            </Tabs>
          </div>
        </div>
      </div>
    </>
  );
};

export default TotalProgramList;
